import { css } from '@genesislcap/web-core';
import { labelStyles } from '../../styles';

export const sharedMuniGridStyles = `
  rapid-grid-pro::part(grid) {
    --ag-cell-horizontal-padding: 8px;
    --ag-font-size: 14px;
    --ag-grid-size: 8px;
  }
`;

export const dealsStyles = css`
  ${sharedMuniGridStyles}

  rapid-grid-pro::part(grid) {
    border-bottom: none;
  }

  .tab-container {
    display: flex;
    flex-direction: column;
    height: 100%;

    .grid-container {
      flex: 1;
    }
  }

  .active-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: flex-start;
  }

  .header {
    display: flex;
    gap: 10px;
    flex: 0;
    align-items: center;
    padding: 10px;

    .header-group {
      display: flex;
      gap: 10px;
      align-items: center;
      flex-wrap: wrap;
    }

    .header-group-date {
      display: flex;
      align-items: center;
      gap: 10px;
      position: relative;

      .header-group-date-toggle {
        width: 172px;
        height: 32px;
        padding: 2px 8px 2px 12px;
        border-radius: 4px;
        border: 1px solid var(--neutral-fill-rest);
        background-color: rgba(135, 155, 166, 0.06);
        box-sizing: border-box;
        font-family: 'Roboto-Regular', 'Roboto', sans-serif;
        color: #f1f1f1;
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;

        rapid-icon {
          color: var(--rapid-ag-header-foreground-color);
        }
      }

      .header-group-date-toggle:hover {
        border-color: var(--neutral-foreground-rest);

        rapid-icon {
          color: var(--neutral-foreground-rest);
        }
      }

      .header-group-date-calendar-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;

        .header-group-date-calendar-actions-item {
          color: #99c8ff;
          cursor: pointer;
          padding: 5px;
        }

        .header-group-date-calendar-actions-item:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
      }

      .header-group-date-calendar {
        z-index: 1;
        position: absolute;
        left: 0;
        padding: 2px;
        top: 100%;
        border-radius: 4px;
        background: #23272c;
      }
    }

    .header-group-right {
      margin-left: auto;
    }
  }

  .deal-tab {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  ${labelStyles}

  .control-with-tooltip {
    display: inline-flex;
    align-items: center;
    position: relative;
  }

  .control-with-tooltip rapid-tooltip::part(tooltip) {
    margin-top: 16px;
    white-space: nowrap;
    background-color: #1c2024;
    color: #fff;
    border: 0.1px solid var(--neutral-stroke-divider-rest);
    border-radius: 4px;
    padding: 6px;
    font-size: 12px;
  }

  .control-icon {
    height: 28px;
    width: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    background: none;
    border-radius: 3px;
    border: none;
  }

  img {
    height: 16px;
    width: auto;
  }

  .control-icon[disabled] {
    opacity: 0.5;
    cursor: inherit;
  }

  .control-icon:not([disabled]):hover::after {
    opacity: 0.5;
  }

  .control-icon[disabled]::after {
    opacity: 0;
  }

  .filter-pill {
    background: var(--accent-fill-rest);
    display: flex;
    align-items: center;
    gap: 5px;
    border-radius: 5px;
    padding: 4px 8px;

    .filter-pill-label {
      white-space: normal;
      overflow: visible;
      max-width: none;
      word-break: break-word;
      flex: 1;
    }

    rapid-icon {
      cursor: pointer;
      margin-left: 5px;
      flex-shrink: 0;
    }
  }
`;
